import { Injectable } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { FormFieldList } from 'ngx-smart-form';
import { History } from '../history/history';
import { HistoryTask, Task } from '../_core/services/task.service';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TaskManagerService {
  tasks: HistoryTask[] | undefined;
  actionTypeFields: FormFieldList = [];
  dependencyFields: FormFieldList = [];

  taskCtrlValue: string | undefined;
  taskFormTitle = '';
  dependencyFormValue: object | undefined;

  tablePage: number | undefined;
  totalData: number = 0;
  tableData: MatTableDataSource<History> | undefined;

  selectedTabIndex = 0;

  praticaCompletionSubscription?: Subscription;

  constructor() {}

  storeFormValue(
    taskCtrlValue: string | undefined,
    taskFormTitle: string,
    dependencyFormValue: object | undefined,
    tablePage: number | undefined,
    tableData: MatTableDataSource<History>,
    totalData: number,
    selectedTabIndex: number
  ) {
    this.taskCtrlValue = taskCtrlValue;
    this.taskFormTitle = taskFormTitle;
    this.dependencyFormValue = dependencyFormValue;
    this.tableData = tableData;
    this.tablePage = tablePage;
    this.totalData = totalData;
    this.selectedTabIndex = selectedTabIndex;
  }

  cleanData() {
    this.tasks = undefined;
    this.taskCtrlValue = undefined;
    this.taskFormTitle = '';
    this.dependencyFormValue = undefined;
    this.tableData = undefined;
    this.tablePage = undefined;
    this.totalData = 0;
    this.selectedTabIndex = 0;
    this.praticaCompletionSubscription?.unsubscribe();
  }
}
